export default "__VITE_ASSET__f3be382c__"